class FetchError extends Error {
  constructor(message) {
    super(message);
    this.name = 'FetchError';
  }
}
export { FetchError };
//# sourceMappingURL=FetchError.js.map
